import React from 'react';

import type {
  NextOrPreviousPayload,
  OpenModalPayload,
  ProductImagesState,
  SetCurrentImagePayload,
} from 'src/components/organisms/ProductImagesCarousel/types';
import type { CatServiceAPIProduct } from 'src/services/cat-service-api/types/CatServiceAPIProduct';
import { ThumbnailsContainer } from '../containers/ThumbnailsContainer';
import { MainProductImage } from './MainProductImage';
import { ProductImagesModal } from './ProductImagesModal/ProductImagesModal';
import * as styles from '../styles/ProductImages.styles';

export interface ProductImagesCarouselStateProps {
  currentImage: ProductImagesState['currentImage'];
  isModalOpen: ProductImagesState['isModalOpen'];
  navigatedBy: ProductImagesState['navigatedBy'];
  product: CatServiceAPIProduct;
  productIsFavourited: boolean;
}

export interface ProductImagesCarouselDispatchProps {
  closeModal: VoidFunction;
  onNextImage: (payload: NextOrPreviousPayload) => void;
  onOpenModal: (payload: OpenModalPayload) => void;
  onPrevImage: (payload: NextOrPreviousPayload) => void;
  onUpdateFavourite: () => void;
  setCurrentImage: (payload: SetCurrentImagePayload) => void;
}

export type ProductImagesCarouselProps = ProductImagesCarouselStateProps &
  ProductImagesCarouselDispatchProps;

export const ProductImagesCarousel = ({
  closeModal,
  currentImage,
  isModalOpen,
  navigatedBy,
  onNextImage,
  onOpenModal,
  onPrevImage,
  onUpdateFavourite,
  product,
  productIsFavourited,
  setCurrentImage,
}: ProductImagesCarouselProps) => {
  const totalImages = product.images.length;
  const location = 'Main image';

  return (
    <>
      <ProductImagesModal
        closeModal={closeModal}
        currentImage={currentImage}
        images={product.images}
        isModalOpen={isModalOpen}
        onNextImage={onNextImage}
        onPrevImage={onPrevImage}
        setCurrentImage={setCurrentImage}
      />
      <MainProductImage
        currentImage={currentImage}
        location={location}
        navigatedBy={navigatedBy}
        onNextImage={onNextImage}
        onOpenModal={onOpenModal}
        onPrevImage={onPrevImage}
        onUpdateFavourite={onUpdateFavourite}
        product={product}
        productIsFavourited={productIsFavourited}
        setCurrentImage={setCurrentImage}
      />
      {totalImages > 1 && (
        <div css={styles.imageThumbnails}>
          <ThumbnailsContainer
            location={location}
            onThumbnailClick={(imageIndex) =>
              setCurrentImage({
                imageIndex,
                navigationType: 'click',
                location,
              })
            }
          />
        </div>
      )}
    </>
  );
};
